import { render, staticRenderFns } from "./ProductDetailCard.vue?vue&type=template&id=107d99aa"
import script from "./ProductDetailCard.vue?vue&type=script&lang=js"
export * from "./ProductDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports